import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { BackgroundImage } from '../types/Images';
import { idbStorage } from './idbStorage';
export var useBackgroundStore = create()(devtools(persist(function (set) { return ({
    background: BackgroundImage.Default,
    updateBackground: function (background) {
        return set(function (state) { return ({ background: background }); });
    },
}); }, {
    name: 'background-image-selected',
    version: 1,
    storage: idbStorage,
    partialize: function (_a) {
        var background = _a.background;
        return ({
            background: background,
        });
    },
})));
